export const adminMenu = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: "bi bi-grid-fill",
  },
  {
    title: "Booking Report",
    url: "/booking-report",
    icon: "bi bi-flag",
  },
  {
    title: "Daily Payment Report",
    url: "/report/daily-report",
    icon: "bi bi-file-earmark-text",
  },
  {
    title: "Payment History",
    url: "/payment-history",
    icon: "bi bi-currency-rupee",
  },
  {
    title: "Room",
    url: "/room",
    icon: "bi bi-house",
  },
  {
    title: "Bed",
    url: "/bed",
    icon: "bi bi-usb-mini",
  },
  {
    title: "Check In",
    url: "/booking",
    icon: "bi bi-calendar-check",
  },
  {
    title: "Check Out",
    url: "/checkout",
    icon: "bi bi-calendar-minus",
  },
  {
    title: "Product",
    url: "/product",
    icon: "bi bi-box2",
  },
  // {
  //     title: "Staff",
  //     url: "/staff",
  //     icon: "bi bi-people",
  // },
  // {
  //     title: "Inventory",
  //     url: "/inventory",
  //     icon: "bi bi-journal-check",
  // }
  // {
  //     title: "Reports",
  //     url: "#",
  //     icon: "bi bi-clock-history",
  //     submenu: [
  //          {
  //             title: "Pay Collection",
  //             url: "report/pay-collection",
  //             icon: "bi bi-currency-rupee",
  //         },
  //         {
  //             title: "Attendance",
  //             url: "report/attendance",
  //             icon: "bi bi-calendar3",
  //         }
  //     ],
  // },
  // {
  //     title: "Catagory",
  //     url: "/course/category",
  //     icon: "bi bi-tag",
  // },
  // {
  //     title: "Course",
  //     url: "/course",
  //     icon: "bi bi-mortarboard",
  // },
  //  {
  //     title: "Batch",
  //     url: "/batch/list",
  //     icon: "bi bi-ui-checks-grid",
  // },
  // {
  //     title: "Attendance History",
  //     url: "/attendance/history",
  //     icon: "bi bi-calendar2-check",
  // },
  // {
  //     title: "Admin Users",
  //     url: "/admin/user/list",
  //     icon: "bi bi-person-fill",
  // },
  // {
  //     title: "Faculty Users",
  //     url: "/faculty/user/list",
  //     icon: "bi bi-people",
  // },
  // {
  //     title: "Student",
  //     url: "/student/list",
  //     icon: "bi bi-people",
  // },
];
